export const flowToIcon = (flow: string): string => {
  switch (flow.toLowerCase()) {
    case 'identity':
      return 'identity_icon.svg'
    case 'financial':
    case 'income':
      return 'financial_icon.svg'
    case 'employment':
      return 'employment.svg'
    case 'residential':
      return 'residential_icon.svg'
    case 'adversecredit':
      return 'credit_search.svg'
    case 'guarantorconsent':
    case 'guarantor':
      return 'guarantor_icon.svg'
    case 'additionaldetails':
      return 'details_icon.svg'
    default:
      return `${flow.toLowerCase()}.svg`
  }
}
